<template>
  <div class="crew-data-range-date-picker">
    <div class="flex justify-start items-center gap-4 w-full">
      <div class="flat-pickr-wrapper relative">
        <feather-icon class="calendar-icon" icon="CalendarIcon" svgClasses="h-4 w-4" @click.stop="onClearButtonClick" />
        <feather-icon v-if="showClear" class="clear-icon" icon="XIcon" svgClasses="h-4 w-4"
          @click.stop="onClearButtonClick" />
        <feather-icon class="arrow-icon" :svgClasses="arrowIconSvgClasses" icon="ChevronDownIcon"
          :style="arrowIconRight" />
        <flat-pickr class="crew-date-range-flat-picker start-date" v-model="selectedDate" :placeholder="placeholder"
          :config.sync="configTimePicker" ref="selectedDatePicker" :disabled="disabled" :style="customStyle" />
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const FLAT_PICKR_CLASS_NAME = "flatpickr-calendar";
const DATE_RANGE_FLAT_PICKR_CLASS_NAME = "crew-date-range-flat-picker";
const STYLE_OVERWRITE = "style-overwrite";

export default {
  name: "DateRangePicker",
  props: {
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    dateFormat: {
      type: String,
      required: false,
      default: "Y/m/d",
    },
    value: {
      type: Array, // [Date|undefined; Date|undefined]
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    customStyle: {
      required: false,
      type: Object,
    },
    arrowIconRight: {
      required: false,
      type: [String, Number],
    },
    arrowIconSvgClasses: {
      type: String,
      default: 'h-4 w-4'
    }
  },
  mixins: [ColorMixin],
  components: {
    flatPickr,
  },
  watch: {
    value: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          this.selectedDate = val;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      lastSelectedDate: null,
      selectedDate: null,
      configTimePicker: {
        enableTime: false,
        dateFormat: this.dateFormat,
        onClose: (
          date // [Date; Date]
        ) => {
          const shouldUpdate = Array.isArray(date) && date.length === 2;
          if (shouldUpdate) {
            this.$emit("update:value", date);
          }
          this.$emit("close");
        },

        minDate: null,
        maxDate: null,
        locale: Japanese,
        mode: "range",
        showMonths: 1,
        monthSelectorType: "static",
      },
    };
  },
  computed: {
    showClear() {
      return this.clearable && this.value != null;
    },
  },

  methods: {
    onClearButtonClick() {
      this.$emit("clear");
    },
  },
  mounted() {
    // flatpickrに独自スタイルを当てるためにclass付与
    document.querySelectorAll(`.${FLAT_PICKR_CLASS_NAME}`).forEach(fc => {
      fc.classList.add(DATE_RANGE_FLAT_PICKR_CLASS_NAME, STYLE_OVERWRITE);
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.crew-data-range-date-picker {
  width: 100%;

  .calendar-icon {
    position: absolute;
    left: 10px;
    top: 11px;
    pointer-events: none;
  }

  .arrow-icon {
    position: absolute;
    right: 12px;
    top: 11px;
    pointer-events: none;
  }

  .clear-icon {
    position: absolute;
    right: 30px;
    top: 11px;
    cursor: pointer;
  }

  ::placeholder {
    color: rgb(186, 186, 186);
    opacity: 1;
    /* Firefox */
  }

  ::-ms-input-placeholder {
    /* Edge 12 -18 */
    color: rgb(186, 186, 186);
  }

  .flatpickr-input {
    padding-left: 34px;
  }

  .flat-pickr-wrapper {
    width: 100%;

    .calendar-icon {
      font-size: 15px;
      top: 50%;
      left: 12px;
      transform: translate(0%, -50%);
    }

    .flatpickr-input {
      border: solid 1px $aisea-light-gray;
      width: 100%;
    }
  }

  .flatpickr-input.active {
    border: 1px solid $aisea-blue !important;
  }
}

.flatpickr-calendar {
  &.crew-date-range-flat-picker {
    width: unset !important; // _datetimePicker.scss に定義されている不要なスタイルを無効化

    .flatpickr-current-month {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: baseline;
      gap: 30px;

      span.cur-month {
        color: #626262;
      }
    }

    .flatpickr-day {

      &.selected,
      &.startRange,
      &.endRange,
      &.selected.inRange,
      &.startRange.inRange,
      &.endRange.inRange,
      &.selected:focus,
      &.startRange:focus,
      &.endRange:focus,
      &.selected:hover,
      &.startRange:hover,
      &.endRange:hover,
      &.selected.prevMonthDay,
      &.startRange.prevMonthDay,
      &.endRange.prevMonthDay,
      &.selected.nextMonthDay,
      &.startRange.nextMonthDay,
      &.endRange.nextMonthDay {
        background: $aisea-blue !important;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: $aisea-blue !important;
      }
    }
  }
}
</style>
